import angular from "angular";
import Vue from "vue";
import "ngVue";
import PDFViewer from "../../components/PDFViewer.vue";

Vue.component("PDFViewer", PDFViewer);

export default angular
  .module("common.directives.pdfViewer", [])
  .directive("pdfViewer", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("PDFViewer"));
    },
  ]);
